<script setup lang="ts">
import { computed } from 'vue';

import { RouterView, useRoute } from 'vue-router';

import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';
import Loader from '@/components/Loader.vue';
import Nav from '@/components/navigation/Nav.vue';
import Tour from '@/components/Tour.vue';
import { useAuthStore } from '@/stores/auth';
import ConnectionError from '@/views/errors/ConnectionError.vue';
import { useDisplay } from 'vuetify';

const authStore = useAuthStore();

const { smAndDown } = useDisplay();

const route = useRoute();

const routeName = computed(() => route.name?.toString() ?? '');
const moduleNameFromUrl = computed(() => route.params.module?.toString() ?? '');

const routesWithoutPageTitle = ['login', 'forgot-password', 'reset-password'];
const routesWithoutFooter = ['login', 'error', 'forgot-password', 'reset-password'];

const pageShouldContainTitle = computed(() => routesWithoutPageTitle.includes(routeName.value));
const pageShouldContainFooter = computed(() => !routesWithoutFooter.includes(routeName.value));
</script>

<template>
    <v-app id="app">
        <v-container fluid :class="[!smAndDown ? 'fill-height' : '', 'app-content']">
            <v-main :class="[!smAndDown ? 'fill-height' : '']">
                <Header :route-name="routeName" :module="moduleNameFromUrl" v-if="!pageShouldContainTitle" />
                <div v-if="authStore.isAuthenticated">
                    <!-- <BackButton /> -->
                    <Tour />
                    <Nav v-if="!pageShouldContainTitle" />
                    <Loader class="loading" />
                    <RouterView class="router-view" />
                </div>
                <div v-else>
                    <Loader class="loading" />
                    <RouterView />
                </div>
            </v-main>
        </v-container>
        <Footer v-if="pageShouldContainFooter" />
        <ConnectionError />
    </v-app>
</template>

<style scoped>
.v-main {
    @media screen and (max-width: 840px) {
        padding-top: 6em;
    }
    @media screen and (min-width: 840px) {
        padding-top: 15em;
    }
}

.router-view {
    padding: 0 30px;

    @media screen and (max-width: 840px) {
        padding: 0 15px;
    }
}
</style>
